import React, { useState } from 'react';
import Table from '../../../Shared/Components/Table';
import { Link } from 'react-router-dom';
import { assignClientToPathwayAsync, removePathwayFromClientAsync } from './../../../Services/CourseService';
import { showToast } from '../../../Infrastructure/Notifications/ToastrConfig';
import PrimaryButton from './../../../Shared/Components/PrimaryButton/PrimaryButton';
import Modal from '../../../Shared/Components/Modal/Modal';
import { getCompletedPathwaysAsync } from '../../../Services/ReportService';

const AssignedPathways = ({ pathways, learningPathways, clientId, getClient }) => {

    const [learningPathwayId, setLearningPathwayId] = useState('');
    const [pathwayToRemove, setPathwayToRemove] = useState({});

    const assignToPathway = async () => {

        let data = {
            clientId: clientId,
            learningPathwayId: learningPathwayId
        }

        let response = await assignClientToPathwayAsync(data);
        if (response) {
            showToast(true, "Assigned pathway to Client");
            setLearningPathwayId('');
        }
        else {
            showToast(false, "Something went wrong");
            setLearningPathwayId('');
        }
        getClient();
    }

    const removeFromPathway = async () => {

        let data = {
            clientId: clientId,
            learningPathwayId: pathwayToRemove.id
        }

        let response = await removePathwayFromClientAsync(data);
        if (response) {
            showToast(true, "Pathway removed from Client")
        }
        else {
            showToast(false, "Something went wrong")
        }
        getClient();
    }

    const handleChange = evt => {
        setLearningPathwayId(evt.target.value);
    }


    const downloadReport = async (id) => {
        getCompletedPathwaysAsync(clientId, id);
    }

    const headings = () => {
        return (<>
            <th>Name</th>
            <th></th>
            <th></th>
        </>)
    }

    const rowData = () => {
        return (<>
            {pathways.length > 0 ?
                pathways.map(
                    (u, i) =>
                        <tr key={i}>
                            <td>
                                {u.name}
                            </td>
                            <td>
                                <span onClick={() => { downloadReport(u.id) }} className="view fas fa-download float-right mr-5" title="Download report"></span>
                            </td>
                            <td>
                                <Link to={`/learning-pathway/${u.id}`} className="btn btn-sm btn-outline-primary action-button float-right mr-3">
                                    View
                                </Link>
                                <span data-target="#removePathway" data-toggle="modal" onClick={() => { setPathwayToRemove(u) }} className="fa fa-trash"></span>
                            </td>
                        </tr>
                )
                :
                <tr>
                    <td className="no-data" colSpan="4">
                        No pathways have yet been assigned to this client
                    </td>
                </tr>
            }
        </>)
    }

    return (
        <>
            <Modal
                modalId="removePathway"
                bodyText={`Are you sure you want to remove ${pathwayToRemove.name} from this client?`}
                buttonFunc={removeFromPathway}
                buttonText="Remove"
                title={`Remove Leaning pathway`}
            />
            <div>
                {/* Assign New Pathway Section */}
                <div style={{
                    background: 'linear-gradient(135deg, #f6f8fb 0%, #ffffff 100%)',
                    borderRadius: '12px',
                    padding: '20px',
                    border: '2px solid #e5e7eb',
                    marginBottom: '24px'
                }}>
                    <label style={{
                        display: 'block',
                        fontSize: '0.9rem',
                        fontWeight: '600',
                        color: '#64748b',
                        marginBottom: '12px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                    }}>
                        Assign New Pathway
                    </label>
                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <select
                            value={learningPathwayId}
                            onChange={handleChange}
                            name="learningPathwayId"
                            className="form-control"
                            style={{
                                flex: '1',
                                padding: '12px 16px',
                                fontSize: '1rem',
                                border: '2px solid #e5e7eb',
                                borderRadius: '8px',
                                transition: 'all 0.2s',
                                height: '48px',
                                lineHeight: '1.5'
                            }}
                        >
                            <option value=''>Assign pathway...</option>
                            {learningPathways.map(lp =>
                                <option key={lp.id} value={lp.id}>{lp.name}</option>
                            )}
                        </select>
                        <PrimaryButton text="Assign" func={assignToPathway} classes="action-btn" />
                    </div>
                </div>

                {/* Current Pathways Table */}
                <div style={{
                    background: 'white',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    border: '1px solid #e5e7eb'
                }}>
                    <Table rowData={rowData} headings={headings} />
                </div>
            </div>
        </>
    );
};

export default AssignedPathways;